import React from "react";
import { HeaderContainer, H1, PageLinkDiv, Link } from "../../styles/Header";

function Header(props) {
	// props
	const { currentRoute } = props
	return (
		<HeaderContainer>
			{/* Dynamic name */}
			<H1>{currentRoute?.routeName}</H1>
			<PageLinkDiv
				className="ec-breadcrumbs"
				aria-label="Breadcrumbs"
				role="region"
			>
				<Link href="">Store</Link>&ensp;/&ensp;
				<Link href={currentRoute?.routeName} className="text-uppercase">
					{currentRoute?.routeName}
				</Link>
			</PageLinkDiv>
		</HeaderContainer>
	);
}

export default Header;
